<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.aroma.list")}}</span>
    <div class="searchable-list-container">
      <AveineReferentialList
        :model="model"
        resource="aromas"
        entity="aromas"
        group-field="family"
        :group-label="$t('intranet.referential.attributes.family')"
        :APIbaseURL="APIbaseURL"
      />
    </div>
  </div>
</template>

<script>
import AveineReferentialList from '@/components/AveineReferentialList.vue'
import Aroma from '@/store/models/aroma'

export default {
  name: 'Index',
  components: { AveineReferentialList },
  data () {
    return {
      model: Aroma,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  }
}
</script>
